import './app.js';
import '../scss/home.scss';


import { AjaxLoadMore } from "./js-modules/ajax";
import sliderHero from "./js-modules/slider-hero";

window.addEventListener("DOMContentLoaded", function () {
    sliderHero();
    AjaxLoadMore();
});